export type ScriptFileValidationReason = 'unsupported_format' | 'invalid_encoding';

export type ScriptFileValidationResult =
  | { ok: true }
  | { ok: false; reason: ScriptFileValidationReason };

export const SCRIPT_UPLOAD_ACCEPT = '.md,.txt';

const ALLOWED_SCRIPT_EXTENSIONS = ['.md', '.txt'];

export function isAllowedScriptFileExtension(fileName: string): boolean {
  const lower = fileName.trim().toLowerCase();
  return ALLOWED_SCRIPT_EXTENSIONS.some((extension) => lower.endsWith(extension));
}

export async function validateScriptUploadFile(file: File): Promise<ScriptFileValidationResult> {
  if (!isAllowedScriptFileExtension(file.name)) {
    return { ok: false, reason: 'unsupported_format' };
  }

  if (typeof TextDecoder === 'undefined') {
    return { ok: false, reason: 'invalid_encoding' };
  }

  try {
    const bytes = await file.arrayBuffer();
    new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    return { ok: true };
  } catch {
    return { ok: false, reason: 'invalid_encoding' };
  }
}

export function getScriptFileValidationMessageKey(reason: ScriptFileValidationReason): string {
  return reason === 'unsupported_format'
    ? 'script.fileFormatOnly'
    : 'script.fileEncodingUtf8Only';
}
